import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Root, { loader as rootLoader,  action as rootAction, }  from './pages/Home';
import  Account  from "./pages/account"
import reportWebVitals from './reportWebVitals';
import {
  // createBrowserRouter,
  createHashRouter,
  RouterProvider,
  Navigate
  // Route,
} from "react-router-dom";
import ErrorPage from "./pages/error";
import Contact from "./pages/contact";
import ResetPassword from "./pages/account/resetPassword";
import SignUp , {  action as singUpAction }  from "./pages/account/signUp";
import SignIn ,  {  action as singInAction }  from "./pages/account/signIn" 



const router = createHashRouter([
  {
    path: "/account",
    element: <Account/>,
    errorElement: <ErrorPage />,
    children:[
      { index: true, element: <Navigate to="sign-in" replace />},
    {
      action:singInAction,
      path: "sign-in",
      element:<SignIn/>,
    },
    {
      action: singUpAction,
      path: "sign-up",
      element:<SignUp/>,
    },
    {
      path: "reset-password",
      element:<ResetPassword/>,

    }
  ]
  },
  {
    path: "/",
    element: <Root/>,
    errorElement: <ErrorPage />,
    loader: rootLoader,
    action: rootAction,
    children:[{
        path: "contacts/:contactId",
        element:<Contact/>,

    }]
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);

